export const adaptTiposReporteBOT = (tiposReporteData) => {
    return {
        id: tiposReporteData?.codigo,
        displayName: tiposReporteData?.descripcion,
        name: tiposReporteData?.descripcion
    }
}

export const adaptTiposReporteBOTArray = (
    tipoReporte
) => {   
    return structuredClone(tipoReporte)
        ?.map(tipoReporte => adaptTiposReporteBOT(tipoReporte));
}